import React, { useEffect, useState } from 'react';
import {
  Grid,
} from 'vindi-ds-components';
import useToggle from '@hooks/feature_toggles';
import { useParams } from 'react-router-dom';
import api from '@services/api';
import Plans from './components/plans';
import Historic from './components/historic';
import Pricing from './components/pricing';
import ResumeProduct from './components/resume_product';
import ShowProductHeader from './components/header';
import PriceSimulator from './components/pricing_simulator';

const RenderPlansAndProduct = ({ product }) => (
  <Grid container spacing={3} display='flex' justify='center'>
    <Grid item sm={7}>
      <Pricing product={product} />
      <Plans plans={product.plans} />
      <Historic historic={product.historic} />
    </Grid>
    <Grid item sm={3}>
      <ResumeProduct
        invoice={product.invoice}
        status={product.status}
        id={product.id}
        plans={product.plans.empty ? 'Produto recorrente' : 'Produto avulso'}
      />
      <PriceSimulator pricingSchema={product.pricing_schema} />
    </Grid>
  </Grid>
);

function ShowProduct() {
  const toggle = useToggle('new_product_page');
  const { id } = useParams();
  const [product, setProduct] = useState();
  const [verify, setVerify] = useState(false);

  useEffect(() => {
    if (toggle) {
      api.get(`/admin/products/${id}`).then((response) => {
        setProduct(response.data.product);
        setVerify(true);
      });
    }
  }, [toggle]);

  if (verify) {
    return (
      <>
        <ShowProductHeader name={product.name} id={product.id} />
        <RenderPlansAndProduct product={product} />
      </>
    );
  }
  return null;
}

export default ShowProduct;
